import { useState, useCallback } from "react";
import Navbar from "@/components/landing/Navbar";
import FeaturesMarquee from "@/components/landing/FeaturesMarquee";
import HeroSection from "@/components/landing/HeroSection";
import LotterySection from "@/components/landing/LotterySection";
import StatsStrip from "@/components/landing/StatsStrip";
import FeaturesGrid from "@/components/landing/FeaturesGrid";
import PricingSection from "@/components/landing/PricingSection";
import Footer from "@/components/landing/Footer";
import AuthModal from "@/components/landing/AuthModal";
import Seo from "@/components/Seo";
import PromoBanner from "@/components/PromoBanner";

const Index = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [authModal, setAuthModal] = useState<{
    open: boolean;
    tab: "login" | "signup";
    intendedTier: "free" | "pro" | "premium" | null;
  }>({
    open: false,
    tab: "login",
    intendedTier: null,
  });

  const openLogin = useCallback(
    () => setAuthModal({ open: true, tab: "login", intendedTier: null }),
    [],
  );
  const openSignup = useCallback(
    (intendedTier: "free" | "pro" | "premium" | null = null) =>
      setAuthModal({ open: true, tab: "signup", intendedTier }),
    [],
  );
  const closeAuth = useCallback(() => setAuthModal((s) => ({ ...s, open: false })), []);

  return (
    <div className="min-h-screen">
      <Seo
        title="LotoTerminal — Inteligência e Análise para Loterias"
        description="Análise estatística, gerador inteligente e dados transparentes das loterias da Caixa: Mega-Sena, Lotofácil, Quina e Dupla Sena."
        path="/"
      />
      <Navbar onLogin={openLogin} onSignup={openSignup} />
      <FeaturesMarquee />
      <PromoBanner variant="large" />
      <main className="min-w-0">
        <HeroSection onSignup={openSignup} />
        <LotterySection />
        <StatsStrip />
        <FeaturesGrid activeFeature={activeFeature} onFeatureClick={setActiveFeature} />
        <PricingSection onSignup={openSignup} />
        <Footer />
      </main>
      <AuthModal
        open={authModal.open}
        onClose={closeAuth}
        defaultTab={authModal.tab}
        intendedTier={authModal.intendedTier}
      />
    </div>
  );
};

export default Index;
